import apiRequest from './apiRequest';

export type PurchaseOrgCreditPacksResponse = {
  paymentIntentId: string;
};

export default async function postPurchaseOrgCreditPacks(purchaseAmountUSD: number) {
  return apiRequest<PurchaseOrgCreditPacksResponse>(
    'user',
    '/users/purchaseOrgCreditPacks',
    {
      method: 'POST',
      body: JSON.stringify({ purchaseAmountUSD }),
    },
  );
}
